import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/** `/$tenant/assistant` — entrée « Assistant documentaire » hors projet : redirige vers le dernier projet ouvert (lot L08). */
export const Route = createFileRoute('/$tenant/assistant')({ component: AssistantRedirect });

function AssistantRedirect() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="assistant" crumbs={[{ label: t('nav.items.assistant') }]}>
      <ProjectResolver tenantId={tenant} section="assistant" />
    </ConsoleShell>
  );
}
